// services/report.service.js
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'report/';

class ReportService {
    getDriveReport(driveId) {
        return axios.get(API_URL + `drive/${driveId}`, {
            headers: authHeader()
        });
    }

    getDriveReportExcel(driveId) {
        return axios.get(API_URL + `drive/${driveId}/xlsx`, {
            headers: authHeader()
        });
    }

    getMissionReport(missionId) {
        return axios.get(API_URL + `mission/${missionId}`, {
            headers: authHeader()
        });
    }

    getMissionReportExcel(missionId) {
        return axios.get(API_URL + `mission/${missionId}/xlsx`, {
            headers: authHeader()
        });
    }

    getVehicleReport(baliseId, from, to) {
        return axios.get(API_URL + `vehicle/${baliseId}`, {
            headers: authHeader(),
            params: { from, to }
        });
    }

    getVehicleReportExcel(baliseId, from, to) {
        return axios.get(API_URL + `vehicle/${baliseId}/xlsx`, {
            headers: authHeader(),
            params: { from, to }
        });
    }
}

export default new ReportService();
